import React, { useState } from "react";
import { useLanguage } from "./languageContext";
import translations from "./translation.json";
import { toast } from "react-toastify";
import { ApiUrl } from "./ApiUrl";
import * as Yup from "yup";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { internalUsers } from "./constants/userTypes";
import { clearLocalStorage } from "./utils/clearLocalStorage";
import { TEXT } from "./dictionary";
import logo from "./assets/Nexus_logo@3x.png";

function TwoFAScreen({ userData, isDarkMode, setIsDarkMode }) {
  const [token, setToken] = useState(localStorage.getItem("token"));
  const { language } = useLanguage();
  const location = useLocation();
  const parent_id = location.state?.parent_id || null;
  const [loading, setIsLoading] = useState(false);
const [verifiedPhone, setVerifiedPhone] = useState(null);
  const phoneExists = !!userData?.phone;
  const [isPhoneVerified, setIsPhoneVerified] = useState(false);
  const [otpSent, setOtpSent] = useState(false);
const normalizePhone = (phone) => {
  if (!phone) return "";
  return phone.replace(/\D/g, "").slice(-10);
};
  const navigate = useNavigate();
  const initialValues = {
    two_fa_type: "email",
    // phone: "",
    phone: normalizePhone(userData?.phone),
    otp: "",
  };

// const validate = (values) => {
//   const errors = {};
// const phoneChanged = values.phone !== userData.phone;
//   // Validate 2FA type
//   if (!values.two_fa_type) {
//     errors.two_fa_type =
//       translations.alertMessages.select2FAOption[language];
//   }

//   // Validate phone if 2FA type includes phone
//   if (values.two_fa_type === "phone" || values.two_fa_type === "both") {
//     if (!values.phone) {
//       errors.phone = translations.alertMessages.phoneRequired[language];
//     } 
//     // Ensure exactly 10 digits (only digits allowed)
//    else if (!/^\d{10}$/.test(values.phone.replace(/\D/g, "").slice(-10))) {
//   // else if (values.phone.length !== 9) {
//   errors.phone = translations.alertMessages.invalidPhone[language];
// }
//     // Ensure phone is verified
//     else if (!isPhoneVerified && phoneChanged) {
//       errors.phone = "Phone must be verified before saving.";
//     }
//   }

//   return errors;
// };

  const handleSubmit = async (values, { setSubmitting }) => {
     const formattedPhone = `+1${values?.phone.replace(/\D/g, "").slice(-10)}`;
    try {
      const token = localStorage.getItem("token");

      const payload = {
        two_fa: "enabled",
        // two_fa_email:
        //   values.two_fa_type === "email" || values.two_fa_type === "both"
        //     ? "enabled"
        //     : "disabled",
        // two_fa_phone:
        //   values.two_fa_type === "phone" || values.two_fa_type === "both"
        //     ? "enabled"
        //     : "disabled",
        two_fa_email: values.two_fa_type === "email" ? "enabled" : "disabled",

        two_fa_phone: values.two_fa_type === "phone" ? "enabled" : "disabled",
        phone:
          // !phoneExists &&
          // (values.two_fa_type === "phone" || values.two_fa_type === "both")
          (values.two_fa_type === "phone" )

            ? formattedPhone
            : undefined,
      };
      

      const res = await fetch(ApiUrl + "/api/user/client-profile-2fa", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await res.json();

      if (data.status === "success") {
        toast.success(TEXT[language].setup2FASuccess);

        const updatedUser = JSON.parse(localStorage.getItem("userData"));
        updatedUser["two_fa_pop_up"] = true;
        updatedUser["two_fa_email"] =
          values.two_fa_type === "email" || values.two_fa_type === "both"
            ? "enabled"
            : "disabled";
        updatedUser["two_fa_phone"] =
          values.two_fa_type === "phone" || values.two_fa_type === "both"
            ? "enabled"
            : "disabled";

        if ( isPhoneVerified) {
          updatedUser.phone = values.phone;
        }

        localStorage.setItem("userData", JSON.stringify(updatedUser));

        if (internalUsers.includes(updatedUser?.roles[0]?.name)) {
          window.location.href = "/event-portal";
        } else if (
          updatedUser?.roles[0]?.name === "Manager" ||
          updatedUser?.roles[0]?.name === "Employee"
        ) {
          window.location.href = parent_id
            ? "/event-portal" + parent_id
            : "/event-portal";
        } else {
          clearLocalStorage();
          window.location.href = "/login";
        }
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(TEXT[language].somethingWrong);
    } finally {
      setSubmitting(false);
    }
  };

  const handleLogout = async () => {
    setIsLoading(true);
    try {
      const res = await fetch(ApiUrl + "/api/user/logout", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      });
      const data = await res.json();
      if (data.status === "success") {
        clearLocalStorage();
        setToken(null);
        setIsDarkMode(false);
        toast.success(data.message);
        navigate("/");
      } else {
        toast.error(data.message);
      }
      setIsLoading(false);
    } catch (error) {
      toast.error(translations.alertMessages.wentWrong[language]);
      clearLocalStorage();
      setToken(null);
      setIsDarkMode(false);
    }
  };

  const sendOTP = async (phone) => {
      const formattedPhone = `+1${phone.replace(/\D/g, "").slice(-10)}`;
  // console.log("askldjklasdf", formattedPhone);
    try {
      setIsLoading(true);
      const res = await fetch(ApiUrl + "/api/user/send-otp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ phone:formattedPhone,user_id:userData.id }),
      });
      const data = await res.json();
      // console.log("alksdfjas",data)
      if (data.smsstatus === "success") {
        toast.success(translations.EventsPortal.formModal.otpSentSuccess[language] || "OTP sent successfully!");
        setOtpSent(true);
      } else {
        toast.error(data.smsMessage || "Something went wrong!");
      }
    } catch (err) {
      toast.error( translations.alertMessages.wentWrong[language] || "Something went wrong!");
      // console.log("slkadjfsa",err)
    } finally {
      setIsLoading(false);
    }
  };

  const verifyOTP = async (values, setErrors) => {
    try {
      setIsLoading(true);
      const res = await fetch(ApiUrl + "/api/user/verifyOtp", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          email: userData?.email,
          otp:values.otp,
        }),
      });
      const data = await res.json();
      if (data.status === "success") {
        toast.success(translations.EventsPortal.formModal.phoneVerifiedSuccess[language] || "Phone verified successfully!");
        setIsPhoneVerified(true);
        setVerifiedPhone(values.phone);
        setOtpSent(false);
        setErrors({})
      } else {
        toast.error(data.message);
      }
    } catch (err) {
      toast.error(translations.alertMessages.wentWrong[language] || "Something went wrong!");
    } finally {
      setIsLoading(false);
    }
  };
const formatPhoneDisplay = (phone) => {
  if (!phone) return "";
  const digits = phone.replace(/\D/g, "").slice(-10); // always take last 10 digits
  return digits ? `+1 ${digits}` : "";
};
  // Determines if phone/both options should be disabled:
  // Only disabled when no existing phone AND phone is not yet verified
  // (user must first enter + verify a phone number to enable these options)
  const phoneBasedDisabled = !phoneExists && !isPhoneVerified;
const getValidationSchema = (userData, isPhoneVerified) =>
  Yup.object().shape({
    two_fa_type: Yup.string().required(
      translations.alertMessages.select2FAOption[language]
    ),

   phone: Yup.string().when("two_fa_type", {
      // is: (val) => val === "phone" || val === "both",
      is: (val) => val === "phone" ,

      then: (schema) =>
        schema
          .required(translations.alertMessages.phoneRequired[language])
          .test("len", translations.alertMessages.invalidPhone[language], (val) => {
            if (!val) return false;
            return val.replace(/\D/g, "").length === 10;
          })
          .test("verified", translations.EventsPortal.formModal.phoneVerifyRequired[language] || "Phone must be verified before saving.", () => {
            return isPhoneVerified; // 👈 simple check now
          }),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
  return (
    <div className="two-fa-screen form-wrapper d-flex justify-content-center align-items-center py-5 position-relative">

      {/* Logout */}
      <button
        type="button"
        className="btn two-fa-screen-btn-light position-absolute top-0 end-0 m-3"
        onClick={handleLogout}
        disabled={loading}
      >
        <i className="bi bi-box-arrow-left"></i>{" "}
        {translations.topAndsidebar.logout[language]}
      </button>

      <main
        className="form-signin p-4 shadow rounded bg-white"
        style={{ maxWidth: "500px", width: "100%" }}
      >
        {/* Logo */}
        <div className="d-flex justify-content-center mb-4">
          <Link to="/">
            <img className="logo" width="100" src={logo} alt="Logo" />
          </Link>
        </div>

        {/* Heading */}
        <h3 className="text-center mb-1">
          {translations.EventsPortal.formModal.twoFASetup[language]}
        </h3>
        <p className="text-center text-muted mb-4 small">
          {translations.EventsPortal.formModal.twoFAText[language]}
        </p>

        <Formik
          initialValues={initialValues}
          validationSchema={getValidationSchema(userData, isPhoneVerified)}
          onSubmit={handleSubmit}
          validateOnChange={true}
          validateOnBlur={false}
        >
          {({errors, values, isSubmitting, setFieldValue,setErrors,validateField ,touched }) => {
            // const needsPhoneInput =
            //   !phoneExists &&
            //   (values.two_fa_type === "phone" || values.two_fa_type === "both");
            const phoneChanged = values.phone !== userData.phone;
            const needsPhoneInput = values.two_fa_type === "phone" ;
            // || values.two_fa_type === "both"

            return (
              <Form>
                {/* 2FA Type Selection */}
                <div className="mb-3">
                  <label className="form-label fw-semibold">
                    {translations.EventsPortal.formModal.select2FA[language]}
                  </label>
                  <div className="d-flex gap-4 mt-1">
                    {/* Email — always enabled */}
                    <label className="form-check-label d-flex align-items-center">
                      <Field
                        type="radio"
                        name="two_fa_type"
                        value="email"
                        className="form-check-input me-2"
                      />
                      {translations.EventsPortal.formModal.emailOption[language]}
                    </label>

                    {/* Phone — always selectable; verification enforced at submit */}
                    <label
                      className={`form-check-label d-flex align-items-center ${
                        phoneBasedDisabled ? "text-muted" : ""
                      }`}
                      title={
                        phoneBasedDisabled
                          ? "Enter and verify a phone number first"
                          : ""
                      }
                    >
                      <Field
                        type="radio"
                        name="two_fa_type"
                        value="phone"
                        className="form-check-input me-2"
                      />
                      {translations.EventsPortal.formModal.phoneOption[language]}
                    </label>

                    {/* Both — always selectable; verification enforced at submit */}
                    {/* <label
                      className={`form-check-label d-flex align-items-center ${
                        phoneBasedDisabled ? "text-muted" : ""
                      }`}
                      title={
                        phoneBasedDisabled
                          ? "Enter and verify a phone number first"
                          : ""
                      }
                    >
                      <Field
                        type="radio"
                        name="two_fa_type"
                        value="both"
                        className="form-check-input me-2"
                      />
                      {translations.EventsPortal.formModal.bothOption[language]}
                    </label> */}
                  </div>
                  <ErrorMessage
                    name="two_fa_type"
                    component="div"
                    className="error text-danger mt-1"
                  />
                </div>

                {/* Phone input + OTP — only shown when no existing phone and phone-based option selected */}
                {needsPhoneInput && (
                  <>
                    {/* Phone number field */}
                    <div className="mb-3">
                      <label className="form-label fw-semibold">
                        {translations.EventsPortal.formModal.phoneLabel[language]}
                      </label>
                      {/* <Field
                        type="text"
                        name="phone"
                        className="form-control mt-1"
                        placeholder={
                          translations.EventsPortal.formModal.phonePlaceholder[
                            language
                          ]
                        }
                        // Reset verification state if user changes the phone number
                        onChange={(e) => {
                          setFieldValue("phone", e.target.value);
                          setFieldValue("otp", "");
                          setIsPhoneVerified(false);
                          setOtpSent(false);
                        }}
                      /> */}
                      <Field
                        type="text"
                        name="phone"
                        className="form-control mt-1"
                        placeholder={translations.EventsPortal.formModal.phonePlaceholder[language]}
                        // value={values.phone ? `+1 ${values.phone}` : ""}
                        value={formatPhoneDisplay(values.phone)}
                        onChange={(e) => {
  const raw = e.target.value;
  const withoutPrefix = raw.replace(/^\+1\s?/, "");
  const digitsOnly = withoutPrefix.replace(/\D/g, "").slice(0, 10);

  // If user types back the verified phone, restore verified state
  if (digitsOnly === verifiedPhone) {
    setIsPhoneVerified(true);
  } else {
    setIsPhoneVerified(false); // 👈 reset if different
  }

  setFieldValue("phone", digitsOnly).then(() => {
    validateField("phone");
  });
  setFieldValue("otp", "");
  setOtpSent(false);
}}
                      />
                      <ErrorMessage
                        name="phone"
                        component="div"
                        className="error text-danger mt-1"
                      />
                   
                    </div>

                    {/* Show "Verify Phone" button once a phone is entered and not yet verified */}
                    {values.phone  && !isPhoneVerified && !otpSent && (
                      <div className="mb-3">
                        <button
                          type="button"
                          className="btn w-100 two-fa-screen-btn-light"
                          onClick={() => sendOTP(values.phone)}
                          // disabled={loading}
                          disabled={loading || values.phone.length !== 10}
                        >
                          {loading ? "Sending OTP…" : "Verify Phone"}
                        </button>
                      </div>
                    )}

                    {/* OTP entry — shown after OTP is sent and phone not yet verified */}
                    {otpSent && !isPhoneVerified && (
                      <div className="mb-3">
                        <label className="form-label fw-semibold">
                          Enter OTP
                        </label>
                        <div className="d-flex gap-2">
                          <Field
                            type="text"
                            name="otp"
                            className="form-control mt-1"
                            placeholder="Enter OTP"
                          />
                          <button
                            type="button"
                            className="btn two-fa-screen-btn-light mt-1 "
                            onClick={() => verifyOTP(values, setErrors)}
                            disabled={loading || !values.otp}
                            style={{width:'150px',backgroundColor:'#445775'}}
                          >
                            {loading ? "Verifying…" : "Submit OTP"}
                          </button>
                        </div>
                        {/* Allow resending OTP */}
                        <button
                          type="button"
                          className="btn two-fa-screen-btn-light mt-3 "
                          onClick={() => sendOTP(values.phone)}
                          disabled={loading}
                          style={{width:'150px',backgroundColor:'#445775'}}
                        >
                          Resend OTP
                        </button>
                      </div>
                    )}

                    {/* Verified badge */}
                    {isPhoneVerified && (
                      <div className="mb-3 text-success small fw-semibold">
                        <i className="bi bi-check-circle-fill me-1"></i>
                        {/* Phone verified */}
                        {translations.EventsPortal.formModal.phoneVerified[language]}
                      </div>
                    )}
                  </>
                )}

                {/* Submit */}
                <button
                  className="w-100 btn admin-btn btn-primary btn-lg mt-3"
                  type="submit"
                  disabled={isSubmitting || loading}
                >
                  {translations.EventsPortal.formModal.save2FA[language]}
                </button>
              </Form>
            );
          }}
        </Formik>
      </main>
    </div>
  );
}

export default TwoFAScreen;